import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootGridList: {
        padding: '10px',
        height: '400px',
    },
    rootGridContainer: {
        margin: '0 0 20px',
    },
    quantityVoucher: {
        pointerEvents: 'none',
    },
    rootAccordion: {
        boxShadow: 'unset',
        '&$expandedAccordion': {
            margin: '0 !important',
        }
    },
    expandedAccordion: {
        //required
    },
    rootAccordionSummary: {
        padding: '0',
        border: '1px solid white',
        '&$expandedAccordionSummary': {
            border: '1px solid #0492C2',
            borderRadius: '20px',
            [theme.breakpoints.down('sm')]: {
                minHeight: 'fit-content',
            },
        },
    },
    contentAccordionSummary: {
        margin: '0',
        '&$expandedAccordionSummary':{
            margin: '0',
        }
    },
    expandedAccordionSummary: {
        //required
    },
    rootGridVoucher: {
        background: '#FFFFFF',
        borderRadius: '20px',
        boxShadow: '0px 0px 7px rgba(0, 0, 0, 0.25)',
        padding: '10px',
        fontSize: themeCommon.fontSize20px,
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
            padding: '20px 10px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
            padding: '20px 10px',
        },
    },
    rootGridVoucherLog: {
        padding: '20px !important',
        marginBottom: '20px',
        fontSize: themeCommon.fontSize16px,
        [theme.breakpoints.down('md')]: {
            padding: '20px 8px !important',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '20px 8px !important',
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('xs')]: {
            padding: '20px 5px !important',
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootGridDescription: {
        fontFamily: themeCommon.RobotoBold,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    containerImage: {
        width: '100px',
        height: '60px',
        '& > img': {
            width: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '50px',
            height: '30px',
        }
    },
    containerDescription: {
        paddingLeft: '10px',
        width: 'calc(100% - 100px)',
        fontSize: themeCommon.fontSize18px,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            width: 'calc(100% - 50px)',
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    containerDescriptionLog: {
        paddingLeft: '0',
    },
    rootGridCategory: {
        color: '#2F2F2F',
        opacity: 0.6,
        fontSize: themeCommon.fontSize18px,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    containerImgae: {
        cursor: 'pointer',
        width: '40px',
        height: '40px',
        '& > img': {
            width: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '30px',
            height: '30px',
        }
    },
    containerInput: {
        '& > input': {
            width: '40px',
            height: '40px',
            textAlign: 'center',
            border: '1px solid #D7D7D7',
            borderRadius: '5px',
            [theme.breakpoints.down('sm')]: {
                width: '30px',
                height: '35px',
            },
        },
    },
    accordionDetailsRedeem: {
        padding: '8px 8px 16px'
    },
    containerRedeem: {
        fontSize: themeCommon.fontSize18px,
        '& > div': {
            margin: '0 5px',
            [theme.breakpoints.down('sm')]: {
                margin: '0 5px',
            },
            [theme.breakpoints.down('xs')]: {
                margin: '0 2px',
            },
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'space-between',
        },
    },

    // Button Redeem
    containerButtonRedeem: {
        height: '50px',
        width: '155px',
        fontSize: themeCommon.fontSize18px,
        color: '#FFFFFF',
        // border: `1px solid ${themeCommon.lightBlue}`,
        // borderRadius: '10px',
        fontFamily: themeCommon.RobotoBold,
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
            height: '35px',
            width: '150px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '120px',
        },
    },
    buttonDisabled: {
        opacity: 0.5,
        pointerEvents: 'none',
    },
    containerButtonContent: {
        background: themeCommon.lightBlue,
        border: `1px solid ${themeCommon.lightBlue}`,
        borderRadius: '10px 0px 0px 10px',
        height: '50px',
        [theme.breakpoints.down('sm')]: {
            height: '35px',
        },
    },
    containerButtonCoin: {
        cursor: 'pointer',
        height: '50px',
        border: `1px solid ${themeCommon.lightBlue}`,
        borderRadius: '0px 10px 10px 0',
        [theme.breakpoints.down('sm')]: {
            height: '35px',
        },
    },

    // Dialog Confirm
    rootDialogConfirm: {
    },
    paperDialogConfirm: {
        borderRadius: '10px',
    },
    rootDialogConfirmTitle: {
        textAlign: 'center',
        fontSize: themeCommon.fontSize16px,
        background: themeCommon.lightBlue,
        color: '#FFFFFF',
        padding: '10px',
        fontFamily: themeCommon.RobotoBold,
    },
    rootDialogConfirmContent: {
        fontSize: themeCommon.fontSize14px,
        padding:'8px 22px',
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize10px,
        },
    },
    dialogContentNote: {
        color: '#DA2A1C',
        margin: '20px 0',
        fontFamily: themeCommon.RobotoBold,
    },
    dialogContentConfirm: {
        margin: '15px 0',
    },
    rootTableContainer: {
        padding: '0 15px',
    },
    rootTableCell: {
        borderBottom: 'unset',
        padding: '10px 1px',
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize10px,
        },
    },
    headTableCell: {
        fontWeight: 700
    },
    rootDialogActions: {
        justifyContent: 'center',
        marginBottom: '20px',
    },
    buttonDialogConfirm: {
        fontSize: themeCommon.fontSize14px,
        fontFamily: themeCommon.RobotoBold,
        borderRadius: '10px',
        width: '100px',
        height: '30px',
        textTransform: 'capitalize',
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize10px,
        },
    },
    buttonAddMember: {
        fontSize: themeCommon.fontSize14px,
        fontFamily: themeCommon.RobotoBold,
        borderRadius: '10px',
        width: '150px',
        height: '30px',
        textTransform: 'capitalize',
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize10px,
        },
    },
    buttonCancle: {
        border: '1px solid #DA2A1C',
        color: '#DA2A1C',
    },
    buttonYes: {
        background: '#4DD091',
        color: '#FFFFFF',
        '&:hover': {
            background: '#4DD091',
        }
    },   
    // button Load more for Log
    containerLoadmore: {
        margin: '50px 0',
        cursor: 'pointer',
        '& > div': {
            fontSize: themeCommon.fontSize22px,
            fontFamily: themeCommon.RobotoBold,
            color: themeCommon.bg_btn,
            [theme.breakpoints.down('xs')]: {
                fontSize: themeCommon.fontSize18px,
            },
        }
    }
}), {
    name: 'RewardHeadContainer',
    index: 1,
})

export default useStyles;